module.exports = __webpack_public_path__ + "static/media/Eila.00726018.jpg";